import { setLanguageBundle } from '@nackle/intl-tools';
import { ENV } from './config.js';

/**
 * Language request
 */
export default async function FetchStrings( token, locale, companyId ) {
    locale = locale || 'en-US';

    const getBundle = async ( bundleName, includeAttribute, getGold ) => {
        if ( !includeAttribute ) {

            const response = await fetch( `https://${ ENV }api.biw.cloud/v2/cmx/bundle/${ encodeURIComponent( bundleName ) }`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'authorization': `Bearer ${ token }`
                },
                body: JSON.stringify( { locales: [ locale ] } )
            } );

            return await response.json();
        } else if ( includeAttribute && !getGold ) {

            const response = await fetch( `https://${ ENV }api.biw.cloud/v2/cmx/bundle/${ encodeURIComponent( bundleName ) }/byAttribute/companyId`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'authorization': `Bearer ${ token }`,
                    'company-id': companyId
                },
                body: JSON.stringify( { locales: [ locale ], attributeValue: companyId } )
            } );

            return await response.json();
        } else if ( getGold ) {
            const response = await fetch( `https://${ ENV }api.biw.cloud/v2/cmx/bundle/${ encodeURIComponent( bundleName ) }/byAttribute/companyId`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'authorization': `Bearer ${ token }`,
                    'company-id': '00000000-0000-0000-0000-000000000000'
                },
                body: JSON.stringify( { locales: [ locale ], attributeValue: '00000000-0000-0000-0000-000000000000' } )
            } );

            return await response.json();
        }
    };

    const bundleData = await Promise.all( [
        //deck strings
        getBundle( 'solution', false ),
        //origami strings
        getBundle( 'origami', false ),
        //regular navigation bundle
        getBundle( 'navigation', false ),
        //gold company nav bundle by attribute
        getBundle( 'navigation', true, true ),
        //company nav bundle by attribute
        getBundle( 'navigation', true )
    ] );


    let mergedBundle = {};
    for ( let i = 0; i < bundleData.length; i++ ) {
        if ( bundleData[ i ].bundles[ locale ] ) {
            Object.keys( bundleData[ i ].bundles[ locale ] ).forEach( k => {
                // make it a string instead of an Array since the attribute keys for nav are arrays
                if ( typeof bundleData[ i ].bundles[ locale ][ k ] !== 'string' && bundleData[ i ].bundles[ locale ][ k ] !== null ) {
                    bundleData[ i ].bundles[ locale ][ k ] = bundleData[ i ].bundles[ locale ][ k ][ 0 ].value;
                }
            } );
        }
        mergedBundle = {
            ...mergedBundle,
            ...bundleData[ i ].bundles[ locale ]
        };
    }

    await setLanguageBundle( locale, mergedBundle );
    return mergedBundle;
}
